// export const BASE_LOGIN_API_URL = 'http://192.168.1.10:8090/users/'
// export const BASE_API_URL = 'http://192.168.1.10:8090/api/'


export const BASE_LOGIN_API_URL = 'http://btaportal.in:8090/users/'
export const BASE_API_URL = 'http://btaportal.in:8090/api/'

export const DOMAIN_URL = 'http://btaportal.in/'
export const MEDIA_URL = 'http://btaportal.in/backend/app/uploads/profile/'
export const MEMBER_MEDIA_URL = 'http://members.btaportal.in/'

// export const DOMAIN_URL = ''
// export const MEDIA_URL = ''

export const PRINT_BASE_URL = 'http://btaportal.in/custom/report/'
// export const PRINT_BASE_URL = 'http://192.168.1.3:80/report/report/'

export const TAP_SPECIAL_DAILY_PRINT_URL = PRINT_BASE_URL +  'tap/print_special_chat/'
export const TAP_ADULT_COAHING_PRINT_URL = PRINT_BASE_URL +  'tap/printdailybooking/'
export const TAP_SPECIAL_DAILY_PRINT_URL_EXCEL = PRINT_BASE_URL +  'tap/excel_special_chat/'
export const TAP_ADULT_COAHING_PRINT_URL_EXCEL = PRINT_BASE_URL +  'tap/exceldailybooking/'
export const TAP_COACH_REPORT_URL = PRINT_BASE_URL +  'tap/printcoachreport/'

// export const MEMBER_COLLECTION_PRINT_URL = PRINT_BASE_URL +  'member/printpdf/'
export const MEMBER_COLLECTION_PRINT_URL = PRINT_BASE_URL +  'member/student_collection_report/'
export const MEMBER_COLLECTION_PRINT_URL_EXCEL = PRINT_BASE_URL +  'member/student_collection_excel/'
export const MEMBER_OUTSTANDING_PRINT_URL = PRINT_BASE_URL +  'member/student_outstanding/'
export const MEMBER_OUTSTANDING_PRINT_URL_EXCEL = PRINT_BASE_URL +  'member/student_outstanding_excel/'
export const MEMBER_OUTSTANDING_MONTHLY_PRINT_URL_EXCEL = PRINT_BASE_URL +  'member/student_outstanding_month_wise_excel/'
export const MEMBER_OUTSTANDING_DUE_PRINT_URL = PRINT_BASE_URL +  'member/student_outstanding/'
export const MEMBER_OUTSTANDING_DUE_MONTHLY_PRINT_URL = PRINT_BASE_URL +  'member/student_outstanding_month_wise/'

export const MEMBER_ADVANCED_REPORT_PDF_URL = PRINT_BASE_URL + 'member/student_advanced/'
export const MEMBER_ADVANCED_REPORT_EXCEL_URL = PRINT_BASE_URL + 'member/student_advanced_excel/'

export const ALL_MEMBER_PROFILE_URL = PRINT_BASE_URL +  'member/print_profile'
export const ALL_MEMBER_PDF_URL = PRINT_BASE_URL +  'member/print_member'
export const ALL_MEMBER_XLS_URL = PRINT_BASE_URL +  'member/member_excel'

export const ALL_OCCUPATION_XLS_URL = PRINT_BASE_URL + 'getreadyreport/occupation_excel'
export const ALL_TIME_SLOT_XLS_URL = PRINT_BASE_URL + 'getreadyreport/time_slot_excel'
export const ALL_CLUB_XLS_URL = PRINT_BASE_URL + 'getreadyreport/club_excel'
export const ALL_TOURNAMENT_XLS_URL = PRINT_BASE_URL + 'getreadyreport/tournament_excel'
export const ALL_CUSTOMER_XLS_URL = PRINT_BASE_URL + 'getreadyreport/customer_excel'
export const ALL_COMMERCIAL_HEAD_XLS_URL = PRINT_BASE_URL + 'getreadyreport/commercial_head_excel'
export const ALL_COACH_XLS_URL = PRINT_BASE_URL + 'getreadyreport/coach_excel'

export const STUDENT_IDS_PRINT_URL = PRINT_BASE_URL +  'member/profile_id'
export const CONTACT_INFO_PRINT_URL = PRINT_BASE_URL +  'member/contactinfo'
export const HOLIDAY_LIST_PRINT_URL = PRINT_BASE_URL +  'tap/holidayprint'

export const TAP_MEMBER_PDF_URL = PRINT_BASE_URL +  'member/tap_member'
export const TAP_MEMBER_XLS_URL = PRINT_BASE_URL +  'member/tap_member_excel'
export const GYM_MEMBER_PDF_URL = PRINT_BASE_URL +  'member/gym_member'
export const GYM_MEMBER_XLS_URL = PRINT_BASE_URL +  'member/gym_member_excel'


export const TAP_INVOICE_BOOKING_LIST_PDF_URL = PRINT_BASE_URL +  'tap/invoicebookinglist'

export const CLUB_LIST_PRINT_URL = PRINT_BASE_URL +  'tap/clubprint'
export const CLUB_AFFILIATION_XLS_URL = PRINT_BASE_URL +  'otherreport/club_affiliation_excel'
export const CLUB_AFFILIATION_REPORT_XLS_URL = PRINT_BASE_URL +  'member/club_affiliation_excel'
export const STUDENT_WISE_COLLECTION = PRINT_BASE_URL +  'otherreport/printpdfenrolment'




//https://pitch.com/public/dae536a1-5327-493f-8f76-62f4ca8e3a5c
